module.exports = __webpack_public_path__ + "static/media/playIconTextWhite.cca2e85c.svg";